(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const debug = (() => {
      try {
        return new URLSearchParams(window.location.search).has('sf_debug');
      } catch (e) {
        return false;
      }
    })();

    const getEventTarget = (e) => {
      const t = e && e.target;
      if (t instanceof Element) return t;
      return t && t.parentElement ? t.parentElement : null;
    };

    const getRootFromEl = (el) => {
      if (!el || !(el instanceof Element)) return null;
      return el.closest('[data-section-id]') || document;
    };

    const getDrawerFromRoot = (root) => {
      if (!root) return null;
      const scope = root instanceof Document ? root : root;
      return scope.querySelector ? scope.querySelector('[data-filters-drawer]') : null;
    };

    const openDrawer = (drawer) => {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      if (debug) console.log('[CollectionFilters]', 'open');
    };

    const closeDrawer = (drawer) => {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (debug) console.log('[CollectionFilters]', 'close');
    };

    // Price Slider Functionality
    const initPriceSlider = (root) => {
      if (!root || !root.querySelector) return;
      const priceForm = root.querySelector('[data-price-form]');
      if (!priceForm) return;

      const minSlider = priceForm.querySelector('[data-slider-min]');
      const maxSlider = priceForm.querySelector('[data-slider-max]');
      const fill = priceForm.querySelector('[data-slider-fill]');
      const minDisplay = priceForm.querySelector('[data-min-display]');
      const maxDisplay = priceForm.querySelector('[data-max-display]');

      if (!minSlider || !maxSlider) return;

      const updateSlider = () => {
        let minVal = parseInt(minSlider.value);
        let maxVal = parseInt(maxSlider.value);

        if (minVal > maxVal) {
          const temp = minVal;
          minVal = maxVal;
          maxVal = temp;
        }

        const minPercent = (minVal / minSlider.max) * 100;
        const maxPercent = (maxVal / maxSlider.max) * 100;

        if (fill) {
          fill.style.left = minPercent + '%';
          fill.style.width = (maxPercent - minPercent) + '%';
        }

        if (minDisplay) minDisplay.textContent = minVal + '₺';
        if (maxDisplay) maxDisplay.textContent = maxVal + '₺';
      };

      minSlider.addEventListener('input', updateSlider);
      maxSlider.addEventListener('input', updateSlider);

      // Initialize on load
      updateSlider();
    };

    const initInRoot = (root) => {
      initPriceSlider(root);
    };

    const initAll = () => {
      document.querySelectorAll('[data-section-id]').forEach((sectionRoot) => {
        initInRoot(sectionRoot);
      });

      if (debug) {
        console.log('[CollectionFilters]', 'init', {
          sectionCount: document.querySelectorAll('[data-section-id]').length,
          drawerCount: document.querySelectorAll('[data-filters-drawer]').length,
          toggleCount: document.querySelectorAll('[data-filters-drawer-toggle]').length
        });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    // Variant Selection
    document.addEventListener('click', (e) => {
      const target = getEventTarget(e);
      if (!target) return;

      const swatch = target.closest('.product-card__variant-swatch');
      const pill = target.closest('.product-card__variant-pill');
      const variantBtn = swatch || pill;

      if (variantBtn && !variantBtn.classList.contains('is-disabled')) {
        e.preventDefault();
        e.stopPropagation();

        const card = variantBtn.closest('.product-card');
        if (!card) return;

        // Remove selected from all variants in this card
        card.querySelectorAll('.product-card__variant-swatch, .product-card__variant-pill').forEach(el => {
          el.classList.remove('is-selected');
        });

        // Add selected to clicked variant
        variantBtn.classList.add('is-selected');

        // Update add to cart button with selected variant
        const addToCartBtn = card.querySelector('[data-add-to-cart]');
        if (addToCartBtn) {
          addToCartBtn.setAttribute('data-selected-variant-id', variantBtn.getAttribute('data-variant-id'));
        }

        // Update price display if variant has different price
        const variantTitle = variantBtn.getAttribute('data-variant-title');
        const variantPrice = variantBtn.getAttribute('data-variant-price');
        const priceEl = card.querySelector('.product-card__price');
        if (priceEl && variantPrice) {
          priceEl.textContent = variantPrice;
        }
      }
    });

    const getVariantIdForCard = (card) => {
      const addToCartBtn = card.querySelector('[data-add-to-cart]');
      const selectedVariantId = addToCartBtn?.getAttribute('data-selected-variant-id');
      if (selectedVariantId) return selectedVariantId;

      const selectedSwatch = card.querySelector('.product-card__variant-swatch.is-selected');
      const selectedPill = card.querySelector('.product-card__variant-pill.is-selected');
      const selectedVariant = selectedSwatch || selectedPill;

      if (selectedVariant) return selectedVariant.getAttribute('data-variant-id');

      const defaultBtn = card.querySelector('[data-add-to-cart]');
      return defaultBtn ? defaultBtn.getAttribute('data-default-variant-id') : null;
    };

    document.addEventListener('change', (e) => {
      const target = getEventTarget(e);
      if (!target) return;

      if (target.matches('form.collection-filters input[type="checkbox"], form.collection-filters input[type="number"]')) {
        const form = target.closest('form.collection-filters');
        if (form) form.submit();
      }
    });

    document.addEventListener('click', async (e) => {
      const target = getEventTarget(e);
      if (!target) return;

      const openBtn = target.closest('[data-filters-drawer-toggle]');
      if (openBtn) {
        e.preventDefault();
        if (debug) console.log('[CollectionFilters]', 'toggle_click');
        const root = getRootFromEl(openBtn);
        const drawer = getDrawerFromRoot(root) || document.querySelector('[data-filters-drawer]');
        if (debug && !drawer) console.warn('[CollectionFilters]', 'drawer_not_found_on_open');
        openDrawer(drawer);
        return;
      }

      const closeBtn = target.closest('[data-filters-drawer-close]');
      if (closeBtn) {
        e.preventDefault();
        const root = getRootFromEl(closeBtn);
        const drawer = getDrawerFromRoot(root) || closeBtn.closest('[data-filters-drawer]') || document.querySelector('[data-filters-drawer]');
        closeDrawer(drawer);
        return;
      }

      const btn = target.closest('[data-add-to-cart]');
      if (!btn) return;
      e.preventDefault();

      const card = btn.closest('.product-card');
      if (!card) return;

      const variantId = getVariantIdForCard(card);
      if (!variantId) return;

      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        });

        if (!res.ok) throw new Error('add_to_cart_failed');

        window.location.href = '/cart';
      } catch (err) {
        btn.disabled = false;
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-filters-drawer]').forEach((drawer) => {
        closeDrawer(drawer);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"]) return;
  try {
    
  (() => {
    const debug = (() => {
      try {
        return new URLSearchParams(window.location.search).has('sf_debug');
      } catch (e) {
        return false;
      }
    })();

    const getEventTarget = (e) => {
      const t = e && e.target;
      if (t instanceof Element) return t;
      return t && t.parentElement ? t.parentElement : null;
    };

    const getRootFromEl = (el) => {
      if (!el || !(el instanceof Element)) return null;
      return el.closest('[data-section-id]') || document;
    };

    const getDrawerFromRoot = (root) => {
      if (!root) return null;
      const scope = root instanceof Document ? root : root;
      return scope.querySelector ? scope.querySelector('[data-filters-drawer]') : null;
    };

    const openDrawer = (drawer) => {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      if (debug) console.log('[CollectionFilters]', 'open');
    };

    const closeDrawer = (drawer) => {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (debug) console.log('[CollectionFilters]', 'close');
    };

    // Price Slider Functionality
    const initPriceSlider = (root) => {
      if (!root || !root.querySelector) return;
      const priceForm = root.querySelector('[data-price-form]');
      if (!priceForm) return;

      const minSlider = priceForm.querySelector('[data-slider-min]');
      const maxSlider = priceForm.querySelector('[data-slider-max]');
      const fill = priceForm.querySelector('[data-slider-fill]');
      const minDisplay = priceForm.querySelector('[data-min-display]');
      const maxDisplay = priceForm.querySelector('[data-max-display]');

      if (!minSlider || !maxSlider) return;

      const updateSlider = () => {
        let minVal = parseInt(minSlider.value);
        let maxVal = parseInt(maxSlider.value);

        if (minVal > maxVal) {
          const temp = minVal;
          minVal = maxVal;
          maxVal = temp;
        }

        const minPercent = (minVal / minSlider.max) * 100;
        const maxPercent = (maxVal / maxSlider.max) * 100;

        if (fill) {
          fill.style.left = minPercent + '%';
          fill.style.width = (maxPercent - minPercent) + '%';
        }

        if (minDisplay) minDisplay.textContent = minVal + '₺';
        if (maxDisplay) maxDisplay.textContent = maxVal + '₺';
      };

      minSlider.addEventListener('input', updateSlider);
      maxSlider.addEventListener('input', updateSlider);

      // Initialize on load
      updateSlider();
    };

    const initInRoot = (root) => {
      initPriceSlider(root);
    };

    const initAll = () => {
      document.querySelectorAll('[data-section-id]').forEach((sectionRoot) => {
        initInRoot(sectionRoot);
      });

      if (debug) {
        console.log('[CollectionFilters]', 'init', {
          sectionCount: document.querySelectorAll('[data-section-id]').length,
          drawerCount: document.querySelectorAll('[data-filters-drawer]').length,
          toggleCount: document.querySelectorAll('[data-filters-drawer-toggle]').length
        });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    // Variant Selection
    document.addEventListener('click', (e) => {
      const target = getEventTarget(e);
      if (!target) return;

      const swatch = target.closest('.product-card__variant-swatch');
      const pill = target.closest('.product-card__variant-pill');
      const variantBtn = swatch || pill;

      if (variantBtn && !variantBtn.classList.contains('is-disabled')) {
        e.preventDefault();
        e.stopPropagation();

        const card = variantBtn.closest('.product-card');
        if (!card) return;

        // Remove selected from all variants in this card
        card.querySelectorAll('.product-card__variant-swatch, .product-card__variant-pill').forEach(el => {
          el.classList.remove('is-selected');
        });

        // Add selected to clicked variant
        variantBtn.classList.add('is-selected');

        // Update add to cart button with selected variant
        const addToCartBtn = card.querySelector('[data-add-to-cart]');
        if (addToCartBtn) {
          addToCartBtn.setAttribute('data-selected-variant-id', variantBtn.getAttribute('data-variant-id'));
        }

        // Update price display if variant has different price
        const variantTitle = variantBtn.getAttribute('data-variant-title');
        const variantPrice = variantBtn.getAttribute('data-variant-price');
        const priceEl = card.querySelector('.product-card__price');
        if (priceEl && variantPrice) {
          priceEl.textContent = variantPrice;
        }
      }
    });

    const getVariantIdForCard = (card) => {
      const addToCartBtn = card.querySelector('[data-add-to-cart]');
      const selectedVariantId = addToCartBtn?.getAttribute('data-selected-variant-id');
      if (selectedVariantId) return selectedVariantId;

      const selectedSwatch = card.querySelector('.product-card__variant-swatch.is-selected');
      const selectedPill = card.querySelector('.product-card__variant-pill.is-selected');
      const selectedVariant = selectedSwatch || selectedPill;

      if (selectedVariant) return selectedVariant.getAttribute('data-variant-id');

      const defaultBtn = card.querySelector('[data-add-to-cart]');
      return defaultBtn ? defaultBtn.getAttribute('data-default-variant-id') : null;
    };

    document.addEventListener('change', (e) => {
      const target = getEventTarget(e);
      if (!target) return;

      if (target.matches('form.collection-filters input[type="checkbox"], form.collection-filters input[type="number"]')) {
        const form = target.closest('form.collection-filters');
        if (form) form.submit();
      }
    });

    document.addEventListener('click', async (e) => {
      const target = getEventTarget(e);
      if (!target) return;

      const openBtn = target.closest('[data-filters-drawer-toggle]');
      if (openBtn) {
        e.preventDefault();
        if (debug) console.log('[CollectionFilters]', 'toggle_click');
        const root = getRootFromEl(openBtn);
        const drawer = getDrawerFromRoot(root) || document.querySelector('[data-filters-drawer]');
        if (debug && !drawer) console.warn('[CollectionFilters]', 'drawer_not_found_on_open');
        openDrawer(drawer);
        return;
      }

      const closeBtn = target.closest('[data-filters-drawer-close]');
      if (closeBtn) {
        e.preventDefault();
        const root = getRootFromEl(closeBtn);
        const drawer = getDrawerFromRoot(root) || closeBtn.closest('[data-filters-drawer]') || document.querySelector('[data-filters-drawer]');
        closeDrawer(drawer);
        return;
      }

      const btn = target.closest('[data-add-to-cart]');
      if (!btn) return;
      e.preventDefault();

      const card = btn.closest('.product-card');
      if (!card) return;

      const variantId = getVariantIdForCard(card);
      if (!variantId) return;

      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        });

        if (!res.ok) throw new Error('add_to_cart_failed');

        window.location.href = '/cart';
      } catch (err) {
        btn.disabled = false;
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-filters-drawer]').forEach((drawer) => {
        closeDrawer(drawer);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
